import { render, staticRenderFns } from "./paddleCard.vue?vue&type=template&id=ebe8b344&scoped=true&"
import script from "./paddleCard.vue?vue&type=script&lang=js&"
export * from "./paddleCard.vue?vue&type=script&lang=js&"
import style0 from "./paddleCard.vue?vue&type=style&index=0&id=ebe8b344&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe8b344",
  null
  
)

export default component.exports